<script>
	import { onMount } from "svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";

	import {
		totalPages,
		loading,
		carData,
		trigerBlackoutSearch,
		sizeSelect,
		errorMessage,
		initPage,
		carSelection,
		blackoutCarData,
		editBlackoutData,
	} from "../../../store/store";
	import { getFilteredVehicles } from "../../../services/vehicle";
	import CarManagementTable from "./CarManagementTable.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import ErrorMessageHandler from "src/components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { extractErrorMessage } from "src/utils/misc";

	let data = [];
	let prevInitPage = $initPage;

	function buildQueryParams() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		const search = window.location.search;
		let queryParams = search.includes("page")
			? `?page=${params.page}&size=100`
			: `?page=1&size=100`;

		if (search.includes("StatusIds")) {
			let urlParams = new URLSearchParams(window.location.search);
			let statusIds = urlParams.getAll("StatusIds");
			statusIds.forEach((id) => {
				queryParams = queryParams.concat(`&StatusIds=${id}`);
			});
		}
		if (search.includes("plateNumber"))
			queryParams += `&Keyword=${params.plateNumber}`;
		if (search.includes("startDateRange"))
			queryParams += `&startDate=${params.startDateRange}`;
		if (search.includes("endDateRange"))
			queryParams += `&endDate=${params.endDateRange}`;
		if (search.includes("carMake"))
			queryParams += `&makeId=${params.carMake}`;
		if (search.includes("carpark"))
			queryParams += `&CarParkId=${params.carpark}`;
		if (search.includes("PriceGroupId"))
			queryParams += `&PriceGroupId=${params.PriceGroupId}`;

		return queryParams;
	}

	async function loadVehicles() {
		try {
			loading.set(true);
			const res = await getFilteredVehicles(buildQueryParams());
			data = res.data.dataList;
			data.totalCount = res.data.totalCount;
			carData.set(data);
			totalPages.set(res.data.totalPage);
			sizeSelect.set(res.data.pageSize);
		} catch (err) {
			console.log(err);
			extractErrorMessage(err);
		} finally {
			loading.set(false);
		}
	}

	onMount(() => {
		if (!$editBlackoutData.stats) {
			carSelection.set([]);
			blackoutCarData.set("");
		}
		initPage.set(1);
		prevInitPage = 1;
		loadVehicles();
	});

	$: if ($trigerBlackoutSearch) {
		loadVehicles();
	}

	$: if ($initPage !== prevInitPage) {
		prevInitPage = $initPage;
		loadVehicles();
	}
</script>

<Row>
	<Col xs={12}>
		<div>
			<ErrorMessageHandler message={$errorMessage} />
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Select Car For Blackout" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm
						priceGroup
						plateNumber
						carStatus
						carMake
						carpark
						startDateRange
						endDateRange
						blackoutSearch
					/>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<CarManagementTable {data} />
	</Col>
</Row>
